import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Button, Row } from "antd";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { customBaseUrl, httpPost, httpPut } from "../../../store/http";
import { Grid, Switch } from "@mui/material";
import { useMatStyles } from "./style";
import { hideLoader, showLoader } from "../../../utils/loader";
import { Add, ArrowBack } from "@mui/icons-material";
import AntDropdown from "../../../components/CustomDropdown/AntDropdown";
import noDataLogo from "../../../assets/images/no-data.png";
import RefTypeModal from "./newTypeModal";
import EditTypeModal from "./EditTypeModal";
import Swal from "sweetalert2";

const ReferralTypes = ({ setShowRefTypes }) => {
  const [pagination, setPagination] = useState({
    current: 0,
    pageSize: 10,
  });
  const styles = useMatStyles();
  const [allTransfers, setAllTransfers] = useState(0);
  const [allReferrals, setAllreferrals] = useState([]);
  const [showEditDays, setShowEditDays] = useState(false);
  const [showEditType, setShowEditType] = useState(false);
  const [selectedRow, setSelectRow] = useState([]);

  const getReferralTypes = useCallback(async (page, size) => {
    setAllreferrals([]);
    showLoader();
    const pages = page ?? pagination.current;
    const limit = size ? size : pagination.pageSize;
    let request = await httpPost(
      `${customBaseUrl.referralUrl}/api/v1/referral_type/view_report`,
      {
        pageNo: pages,
        pageSize: limit,
      }
    );
    if (request.status) {
      setAllreferrals(request.data.content || []);
      setAllTransfers(request.data.totalElements || 0);
    }
    hideLoader();
  }, [pagination.current, pagination.pageSize]);

  const handleToggler = useCallback(async (row, status) => {
    showLoader();
    let res = await httpPut(`${customBaseUrl.referralUrl}/api/v1/referral_type/update_referral_type/${row?.referralTypeId}/${status}`, {});

    if (res.status) {
      hideLoader();
      getReferralTypes();
      Swal.fire('Success', res.message, 'success');
    } else {
      hideLoader();
      Swal.fire('Failed', res.message, 'error');
    }
  }, [getReferralTypes]);

  useEffect(() => {
    getReferralTypes();
  }, [getReferralTypes]);

  const handleChangeRowsPerPage = async (value) => {
    setPagination({ ...pagination, current: 0, pageSize: value });
    await getReferralTypes(0, value);
  };

  const handleChangePage = async (newPage) => {
    setPagination({ ...pagination, current: newPage });
    await getReferralTypes(newPage, pagination.pageSize);
  };

  const handleDropdownAction = useCallback((item, row) => {
    setSelectRow(row);
    if (item === "Edit") setShowEditType(true);
  }, []);

  const columns = useMemo(() => [
    {
      field: 'referralTypeId',
      headerName: 'ID',
      width: 200,
      headerClassName: styles.tableHeader,
    },
    {
      field: 'referralDescription',
      headerName: 'Referral Description',
      width: 200,
      headerClassName: styles.tableHeader,
    },
    {
      field: 'accountTypeEnum',
      headerName: 'Account Type',
      width: 200,
      headerClassName: styles.tableHeader,
    },
    {
      field: 'defaultType',
      headerName: 'Is Default',
      width: 200,
      headerClassName: styles.tableHeader,
      renderCell: ({ row }) => <Switch
        checked={row?.defaultType}
        onChange={(e) => handleToggler(row, e.target.checked)}
        name="defaultType"
        inputProps={{ 'aria-label': 'secondary checkbox' }}
      />
    },
    {
      field: 'numberOfTransactionRequired',
      headerName: 'Tran Count Required',
      width: 250,
      headerClassName: styles.tableHeader,
      renderCell: ({ row }) => row?.numberOfTransactionRequired ? <div style={{ color: 'green' }}>TRUE</div> : <div style={{ color: 'red' }}>FALSE</div>
    },
    {
      field: 'numberCount',
      headerName: "Number of Count",
      width: 200,
      headerClassName: styles.tableHeader,
    },
    {
      field: 'dateCreated',
      headerName: "Date Created",
      width: 200,
      headerClassName: styles.tableHeader,
    },
    {
      field: 'dateModified',
      headerName: 'Date Modified',
      width: 250,
      headerClassName: styles.tableHeader,
      renderCell: ({ row }) => row?.dateModified || 'N/A'
    },
    {
      field: 'bonus',
      headerName: "Action ",
      width: 150,
      headerClassName: styles.tableHeader,
      renderCell: ({ row }) => (
        <AntDropdown
          dropDownOptions={["Edit"]}
          handleDropdownAction={(item) => handleDropdownAction(item, row)}
          userId={row}
          isArrow
        />
      ),
    },
  ], [styles.tableHeader, handleToggler, handleDropdownAction]);

  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "30px" }}>
        <div>
          <ArrowBack style={{ cursor: 'pointer' }} onClick={() => setShowRefTypes(false)} />
        </div>
        <Row type="flex" justify="end" align="middle">
          <Button
            onClick={() => setShowEditDays(true)}
            size="medium"
            style={{ fontSize: "14px" }}
          >
            <Row>
              <Add />
              Add Referral Type
            </Row>
          </Button>
        </Row>
      </div>

      <div>
        <Grid
          style={{ marginTop: "10px" }}
          container
          spacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 4 }}
        />

        {allReferrals?.length > 0 ? (
          <div style={{ height: 800, width: "100%" }}>
            <DataGrid
              getRowId={row => row.referralTypeId || row.id}
              className={styles.table}
              density="comfortable"
              rows={allReferrals}
              columns={columns}
              page={pagination.current}
              paginationMode="server"
              pageSize={pagination.pageSize}
              onPageSizeChange={handleChangeRowsPerPage}
              onPageChange={handleChangePage}
              rowsPerPageOptions={[5, 10, 20, 50, 100]}
              pagination
              components={{ Toolbar: GridToolbar }}
              rowCount={allTransfers}
            />
          </div>
        ) : (
          <>
            <Row
              type="flex"
              justify="center"
              align="middle"
              className="mt-5"
              style={{ minHeight: "40vh" }}
            >
              <img src={noDataLogo} alt="nodata" style={{ height: "300px" }} />
            </Row>
            <h4 className="mt-3 text-center">No Request yet</h4>
            <p className="mt-3 text-center" style={{ color: '#8C8C8C' }}>
              Request will appear here when you have data
            </p>
          </>
        )}
      </div>

      {showEditDays && <RefTypeModal getReferralTypes={getReferralTypes} showModal={showEditDays} hideModal={setShowEditDays} title="Create Referral Type" className={styles.modal} />}
      {showEditType && <EditTypeModal typeData={selectedRow} getReferralTypes={getReferralTypes} showModal={showEditType} hideModal={setShowEditType} title="Edit Referral Type" className={styles.modal} />}
    </>
  );
};

export default ReferralTypes;